import * as React from 'react';

function SvgPlayOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.796, d: "M4 4.3v16.4c0 .985.961 1.612 1.753 1.14l14.018-8.39c.685-.41.685-1.49 0-1.9L5.753 3.16C4.96 2.689 4 3.316 4 4.3z" })));
}

export default SvgPlayOutline;
